import React from "react";
import PropTypes from "prop-types";
import { Typography, Box } from "@mui/material";
import { AccessTime as DurationIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { getDurationString } from "../../utils/datetime";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(() => ({
  icon: {
    display: "flex"
  }
}));

const CourseCardDuration = ({ duration }) => {
  const theme = useTheme();
  const classes = useStyles();
  const { t } = useTranslation();

  return duration ? (
    <Box my={0.25} display="flex" alignItems="center">
      <Box mr={1} color={theme.palette.action.disabled}>
        <DurationIcon fontSize="small" className={classes.icon} />
      </Box>
      <Typography variant="body2" color="textSecondary">
        {getDurationString(duration, t)}
      </Typography>
    </Box>
  ) : null;
};

export default CourseCardDuration;

CourseCardDuration.propTypes = {
  duration: PropTypes.string
};
